module.exports = __webpack_public_path__ + "media/images/icons/outlined/box-plot-72e8082fea6c174dbf0715b0ab8693d6.svg";